import { render, staticRenderFns } from "./file-viewer.vue?vue&type=template&id=2c38044a&scoped=true&"
import script from "./file-viewer.vue?vue&type=script&lang=js&"
export * from "./file-viewer.vue?vue&type=script&lang=js&"
import style0 from "./file-viewer.vue?vue&type=style&index=0&id=2c38044a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c38044a",
  null
  
)

export default component.exports